var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ViewerScriptFlowAPI } from './flow-api/ViewerScript';
import { OOIControllerFlowAPI } from './flow-api/OOIController';
import { wrapUserController } from './helpers/wrapUserController';
import { createDangerousPublicDataOverride, } from './helpers/createDangerousPublicDataOverride';
import { createDangerousStylesOverride, } from './helpers/createDangerousStylesOverride';
import { createPanoramaClient } from './panorama';
// imported from code generation wrappers/templates/ControllerEntry.ts
export default (function (controllerFn, _a, optionalDeps) {
    var sentryConfig = _a.sentryConfig, biConfig = _a.biConfig, experimentsConfig = _a.experimentsConfig, fedopsConfig = _a.fedopsConfig, biLogger = _a.biLogger, projectName = _a.projectName, inEditor = _a.inEditor, translationsConfig = _a.translationsConfig, defaultTranslations = _a.defaultTranslations, appName = _a.appName, componentId = _a.componentId, componentName = _a.componentName, persistentAcrossPages = _a.persistentAcrossPages, localeDistPath = _a.localeDistPath, shouldUseEssentials = _a.shouldUseEssentials, withErrorBoundary = _a.withErrorBoundary, multilingualDisabled = _a.multilingualDisabled;
    return function (_a) {
        var controllerConfig = _a.controllerConfig, appData = _a.appData, flowAPI = _a.flowAPI, platformServices = _a.platformServices, wixApi = _a.wixApi, dangerousPublicDataOverride = _a.dangerousPublicDataOverride, dangerousStylesOverride = _a.dangerousStylesOverride;
        return __awaiter(void 0, void 0, void 0, function () {
            var prepopulatedData, panoramaClient, viewerScriptFlowAPI, userControllerPromise, _controllerError, userController, error_1;
            var _b, _c, _d, _e, _f, _g, _h;
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        // If flowAPI passed - it means it's already initialized and we shouldn't provide additional actions.
                        if (flowAPI) {
                            return [2 /*return*/, controllerFn.call(null, {
                                    controllerConfig: controllerConfig,
                                    flowAPI: flowAPI,
                                    appData: appData,
                                    dangerousPublicDataOverride: dangerousPublicDataOverride,
                                    dangerousStylesOverride: dangerousStylesOverride,
                                })];
                        }
                        prepopulatedData = appData.__prepopulated;
                        panoramaClient = createPanoramaClient(controllerConfig.essentials, {
                            componentId: componentId,
                            sentryConfig: sentryConfig,
                            environment: 'Viewer:Worker',
                        });
                        viewerScriptFlowAPI = new ViewerScriptFlowAPI({
                            experimentsConfig: experimentsConfig,
                            projectName: projectName,
                            sentryConfig: sentryConfig,
                            essentials: (_b = platformServices === null || platformServices === void 0 ? void 0 : platformServices.essentials) !== null && _b !== void 0 ? _b : controllerConfig.essentials,
                            platformBI: (_c = platformServices === null || platformServices === void 0 ? void 0 : platformServices.bi) !== null && _c !== void 0 ? _c : controllerConfig.platformAPIs.bi,
                            biLoggerFactory: (_d = platformServices === null || platformServices === void 0 ? void 0 : platformServices.biLoggerFactory) !== null && _d !== void 0 ? _d : (_e = controllerConfig === null || controllerConfig === void 0 ? void 0 : controllerConfig.platformAPIs) === null || _e === void 0 ? void 0 : _e.biLoggerFactory,
                            monitoring: (_f = platformServices === null || platformServices === void 0 ? void 0 : platformServices.monitoring) !== null && _f !== void 0 ? _f : (_g = controllerConfig === null || controllerConfig === void 0 ? void 0 : controllerConfig.platformAPIs) === null || _g === void 0 ? void 0 : _g.monitoring,
                            appData: controllerConfig.appParams,
                            wixAPI: wixApi !== null && wixApi !== void 0 ? wixApi : controllerConfig.wixCodeApi,
                            translationsConfig: translationsConfig,
                            defaultTranslations: defaultTranslations,
                            inEditor: inEditor,
                            biConfig: biConfig,
                            biLogger: biLogger,
                            appName: appName,
                            prepopulatedData: prepopulatedData,
                            optionalDeps: optionalDeps,
                            localeDistPath: localeDistPath,
                            shouldUseEssentials: shouldUseEssentials,
                        });
                        return [4 /*yield*/, viewerScriptFlowAPI.init()];
                    case 1:
                        _j.sent();
                        flowAPI = new OOIControllerFlowAPI({
                            translations: viewerScriptFlowAPI.translations,
                            viewerScriptFlowAPI: viewerScriptFlowAPI,
                            appDefinitionId: (_h = controllerConfig.appParams) === null || _h === void 0 ? void 0 : _h.appDefinitionId,
                            translationsConfig: translationsConfig,
                            componentId: controllerConfig.compId,
                            componentName: componentName,
                            widgetId: controllerConfig.type,
                            biLogger: biLogger,
                            fedopsConfig: fedopsConfig,
                            controllerConfig: controllerConfig,
                            persistentAcrossPages: persistentAcrossPages,
                            sentryConfig: sentryConfig,
                            prepopulatedData: prepopulatedData,
                            shouldUseEssentials: shouldUseEssentials,
                            multilingualDisabled: multilingualDisabled,
                            panoramaClient: panoramaClient,
                        });
                        return [4 /*yield*/, flowAPI.init()];
                    case 2:
                        _j.sent();
                        userControllerPromise = controllerFn({
                            controllerConfig: controllerConfig,
                            flowAPI: flowAPI,
                            appData: appData,
                            dangerousPublicDataOverride: createDangerousPublicDataOverride(flowAPI),
                            dangerousStylesOverride: createDangerousStylesOverride(flowAPI),
                        });
                        _controllerError = null;
                        _j.label = 3;
                    case 3:
                        _j.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, userControllerPromise];
                    case 4:
                        userController = _j.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        error_1 = _j.sent();
                        flowAPI.reportError(error_1);
                        _controllerError = error_1;
                        userController = {};
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/, wrapUserController({
                            controller: userController,
                            translations: flowAPI.translations,
                            experiments: flowAPI.experiments,
                            biLogger: flowAPI.bi,
                            controllerConfig: controllerConfig,
                            flowAPI: flowAPI,
                            experimentsConfig: experimentsConfig,
                            translationsConfig: translationsConfig,
                            appName: appName,
                            componentName: componentName,
                            withErrorBoundary: withErrorBoundary,
                            _controllerError: _controllerError,
                            optionalDeps: optionalDeps,
                            panoramaClient: panoramaClient,
                        })];
                }
            });
        });
    };
});
// TODO: Add component name handler
//# sourceMappingURL=controllerWrapper.js.map